import React from "react";
import { Link } from "react-router-dom";
import LearnHutLogo from "../Logos To be used/learnhut_logo_recolored.png";
import "./PhaseTwo.css";

const faqItems = [
  {
    question: "Worin unterscheidet sich LearnHut von ChatGPT und anderen allgemeinen KI-Tools?",
    answer: [
      "Allgemeine KI-Tools kennen normalerweise weder die Materialien, Lernziele noch die Anforderungen einer konkreten Lehrveranstaltung. Dadurch können Antworten entstehen, die nicht zum behandelten Stoff passen oder wichtige Zwischenschritte überspringen.",
      "LearnHut arbeitet fachbezogen mit den vorgesehenen Inhalten einer Lehrveranstaltung. Der Lern-Chat soll Studierende besonders bei Mathematik, Physik und ähnlichen Fächern nicht einfach zur fertigen Lösung führen, sondern Rückfragen stellen, Hinweise geben und einzelne Schritte erklären.",
      "Zusätzlich bietet LearnHut passende Übungen, KI-generierte Aufgaben und Quizze zu den behandelten Inhalten.",
    ],
  },
  {
    question: "Ersetzt LearnHut Professor:innen oder Tutor:innen?",
    answer: [
      "Nein. LearnHut soll Lehre gezielt ergänzen, nicht ersetzen. Lehrende behalten die Kontrolle darüber, welche Materialien, Inhalte und Themen für ihre Lehrveranstaltung genutzt werden.",
      "Viele Studierende nutzen bereits allgemeine KI-Tools ohne Bezug zur konkreten Lehrveranstaltung. LearnHut soll diesen Einsatz in einen klaren fachbezogenen Rahmen bringen und Studierende vor allem außerhalb von Vorlesungen, Übungen und Tutorien unterstützen.",
    ],
  },
  {
    question: "Warum werden Lehrmaterialien in KI-generierte Lektionen umgewandelt?",
    answer: [
      "Die aufbereiteten Inhalte bilden die Grundlage dafür, dass Chat, Aufgaben und Quizze zum tatsächlichen Stoff, zu den Lernzielen und zu den verwendeten Materialien passen.",
      "Für Studierende ist eine strukturierte Lernseite oft aktiver nutzbar als ein PDF allein: Erklärungen, Übungen, Quizze und Hilfen werden an einem Ort verbunden.",
      "Studierende können Feedback zu Lernseiten geben. So werden unklare Erklärungen, Fehler oder fehlende Inhalte sichtbar und LearnHut kann gezielt verbessert werden.",
    ],
  },
  {
    question: "Welche Einblicke erhalten Professor:innen?",
    answer: [
      "Professor:innen sollen anonymisierte und zusammengefasste Hinweise erhalten, zum Beispiel welche Themen häufig aufgerufen oder wiederholt werden, wo viele Quizfehler auftreten oder welche Lernseiten besonders gutes oder kritisches Feedback erhalten.",
      "Diese Hinweise dienen dazu, schwierige oder unklare Inhalte früh zu erkennen. Einzelne Studierende werden dadurch nicht bewertet.",
    ],
  },
  {
    question: "Wie viel zusätzliche Arbeit entsteht für Professor:innen und Tutor:innen?",
    answer: [
      "LearnHut ist darauf ausgelegt, bestehende Lehrmaterialien mit KI in Lektionen aufzubereiten. Die KI kann eine erste Struktur, Erklärungen und Inhalte erstellen, diese Ergebnisse müssen vor der Nutzung aber fachlich geprüft und bei Bedarf korrigiert werden.",
      "Nach bisherigen Erfahrungen hängt der Aufwand stark vom Umfang und der Qualität der Materialien ab. Für eine vollständige Prüfung und Überarbeitung können je nach Lehrveranstaltung etwa eine bis vier Wochen Arbeit entstehen.",
      "Diese Arbeit fällt überwiegend einmal an. Bei späteren Semestern müssen in der Regel nur einzelne Themen, Materialien oder Aufgaben angepasst werden.",
    ],
  },
  {
    question: "Müssen KI-generierte Lektionen geprüft werden?",
    answer: [
      "Ja. KI-generierte Lektionen sollten vor der Veröffentlichung fachlich geprüft und bei Bedarf korrigiert werden. KI kann Inhalte strukturieren und erste Entwürfe erstellen, sie kann aber Fehler machen oder Zusammenhänge missverständlich darstellen.",
      "Mit jeder Testphase verbessern wir die Generierung anhand von Fehlern und Rückmeldungen. Eine fachliche Kontrolle bleibt dennoch wichtig.",
    ],
  },
  {
    question: "Müssen generierte Aufgaben und Quizze geprüft werden?",
    answer: [
      "Nicht zwingend jede einzelne Aufgabe. Nach der Generierung werden Aufgaben und Quizze von zusätzlichen KI-Agenten geprüft, unter anderem auf fachliche Richtigkeit, Lösungsweg und Übereinstimmung zwischen Aufgabe und Lösung.",
      "Trotzdem kann KI nicht zu 100 Prozent fehlerfreie Inhalte garantieren. Professor:innen und Tutor:innen können Aufgaben und Quizze zusätzlich prüfen, wenn sie dies möchten.",
      "Für Studierende soll transparent sichtbar sein, ob ein Inhalt fachlich geprüft wurde oder nur automatisch durch LearnHut überprüft wurde.",
    ],
  },
  {
    question: "Gibt die KI Studierenden direkte Lösungen?",
    answer: [
      "Der Lern-Chat ist besonders bei Rechen- und Denkaufgaben so gestaltet, dass er nicht einfach die vollständige Lösung ausgibt.",
      "Er versucht zuerst zu verstehen, an welchem Schritt jemand nicht weiterkommt, stellt Rückfragen und gibt Hinweise. Ziel ist Verständnisaufbau statt schneller Abgabe einer fertigen Lösung.",
    ],
  },
  {
    question: "Müssen Studierende für LearnHut bezahlen?",
    answer: [
      "Nein. Für Studierende soll LearnHut kostenlos sein. Langfristig sollen Kosten nicht von einzelnen Studierenden getragen werden, sondern über Hochschule, Fakultät oder vergleichbare institutionelle Modelle.",
    ],
  },
  {
    question: "Können Professor:innen einzelne Chats sehen?",
    answer: [
      "Nein. Professor:innen sollen keine einzelnen Chats von Studierenden lesen und nicht sehen, welche Person welche Frage gestellt hat.",
      "Vorgesehen sind nur anonymisierte und zusammengefasste Hinweise, damit Lerninhalte und Unterstützung verbessert werden können.",
    ],
  },
];

function PhaseTwoFaq() {
  return (
    <main className="phase-two-page phase-two-faq-page">
      <header className="phase-two-nav">
        <Link to="/phase-two" className="phase-two-logo-link" aria-label="LearnHut Phase Two">
          <img src={LearnHutLogo} alt="LearnHut" />
        </Link>
        <nav aria-label="FAQ Navigation">
          <Link to="/phase-two">Phase Two</Link>
          <Link to="/phase-two/faq">FAQ</Link>
        </nav>
      </header>

      <section className="phase-two-faq-hero">
        <span className="phase-two-eyebrow">FAQ für Lehrende</span>
        <h1>Häufige Fragen zu LearnHut und der zweiten Testphase.</h1>
        <p>
          Hier finden Sie Antworten zu fachbezogener KI, Prüfaufwand,
          Datenschutz und dem Verhältnis von LearnHut zu bestehenden
          Lehrformaten.
        </p>
      </section>

      <section className="phase-two-faq-list" aria-label="Häufige Fragen">
        {faqItems.map((item, index) => (
          <details className="phase-two-faq-item" key={item.question} open={index === 0}>
            <summary>
              <span>{item.question}</span>
              <strong aria-hidden="true">⌄</strong>
            </summary>
            <div>
              {item.answer.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </details>
        ))}
      </section>

      <section className="phase-two-faq-contact">
        <h2>Weitere Fragen?</h2>
        <p>
          Schreiben Sie uns gerne, wenn Sie konkrete Anforderungen für Ihre
          Lehrveranstaltung besprechen möchten.
        </p>
        <Link to="/phase-two">Interesse anmelden</Link>
      </section>
    </main>
  );
}

export default PhaseTwoFaq;
